import React from 'react';
import Select from 'react-select'
import './Select.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion } from '@fortawesome/free-solid-svg-icons'
import Tooltip from '../Tooltip/Tooltip'
import Modal from '../Modal/Modal'
import Fade from 'react-reveal/Fade';

const SelectBox = (props) => {

    const childRef = React.useRef()

    const showDescription = (event) => {
        childRef.current.openModal()
    }
    const afterCloseModal = (event) => {
    }
    const description =
        <div className="row justify-content-center mt-2 mb-2">
            <div className="col-12 pl-4 pr-4">
                <div className="tooltip-modal">
                    {props.description}
                </div>
            </div>
        </div>
    const tooltipText = <div className="tooltip-cntnr">{props.description}</div>
    const invalid = !!props.className && props.className.split(" ").includes("invalid-select") ? true : false;
    return (
        <div className={`col-md-${props.col != null && props.col != undefined ? props.col : '12'} select-container mb-3`}>
            <div className="floatLabel1">
                <div>
                    <Select
                        menuPortalTarget={props.inModal != null && props.inModal == true ? document.querySelector('.ReactModal__Body--open')
                            : document.querySelector('body')}
                        name="form-field-name"
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999999 }) }}
                        value={props.value}
                        placeholder=""
                        options={props.options}
                        onChange={props.onChange}
                        className={[props.className, "main-select-box"].join(' ')}
                    />
                </div>
                <label htmlFor='car_group' className={props.value !== '' && props.value !== null && props.value != undefined ? 'floatLabelWhenValue1' : 'label1'}>
                    {props.placeholder}
                </label>
                <Fade bottom collapse when={invalid}>
                    <div className="invalidFeedback"
                        style={{ display: 'block' }}
                    >
                        الزامی است
                    </div>
                </Fade>
            </div>

            {props.hasDescription ?
                <div className="description-cntnr" onClick={showDescription}>
                    <Tooltip text={tooltipText} head={
                        <div className="question-cntnr">
                            <div className="question-icon">
                                <FontAwesomeIcon icon={faQuestion} />
                            </div>
                        </div>
                    } />
                </div>
                : ''}


            <Modal
                content={description}
                ref={childRef}
                closeModal={(event) => afterCloseModal(event)}
            />
        </div>
    )
}

export default SelectBox